import {
    createAnalytics,
    createIdentityJwtTokenGetter
} from '@3plearning/mx-teacher-analytics';
import appEvents from './events';

const APP_NAME = 'mathletics-library';
const CORE_GROUP = 'core';
const TEACHER_TOTTER_PRODUCT = 'mathletics';

function resolveEnabledGroups(trackingGroups) {
    if (!trackingGroups) {
        return null;
    }

    const groups = trackingGroups
        .split(',')
        .map(group => group.trim())
        .filter(Boolean);

    return [...groups, CORE_GROUP];
}

export default function buildAnalyticsClient(config) {
    const {
        environment,
        posthogEnabled,
        trackingGroups,
        teacherTotterEnabled,
        teacherTotterSyncUrl,
        identityGatewayUrl,
        getAppAuthToken
    } = config;
    const teacherTotterOn = Boolean(teacherTotterEnabled && teacherTotterSyncUrl);
    const getTeacherTotterAuthToken = createIdentityJwtTokenGetter({
        identityGatewayUrl,
        getAppAuthToken
    });
    const analyticsConfig = {
        app: APP_NAME,
        environment: environment || 'production',
        providers: {
            posthog: posthogEnabled ? { enabled: true } : { enabled: false },
            teacherTotter: {
                enabled: teacherTotterOn,
                syncUrl: teacherTotterSyncUrl,
                product: TEACHER_TOTTER_PRODUCT,
                getAuthToken: getTeacherTotterAuthToken
            }
        },
        enabledFeatureGroups: resolveEnabledGroups(trackingGroups),
        events: appEvents
    };

    try {
        return createAnalytics(analyticsConfig);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[analytics] Initialisation failed; continuing with teacher-totter disabled.', error);

        return createAnalytics({
            ...analyticsConfig,
            providers: {
                ...analyticsConfig.providers,
                teacherTotter: {
                    ...analyticsConfig.providers.teacherTotter,
                    enabled: false
                }
            }
        });
    }
}
